import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as IconMobileMenu } from "../graphicalAssets/icons/menu.svg";
import { ReactComponent as IconMobileMenuClose } from "../graphicalAssets/icons/cross.svg";
import { handleDownloadClick } from "../helpers.js";
import { EMAIL } from "../config.js";

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [shouldRemove, setShouldRemove] = useState(true);
  const [isMenuToggled, setIsMenuToggled] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);

    if (!isMenuToggled) {
      setIsMenuToggled(true);
    }

    if (!isMenuOpen) {
      setShouldRemove(false);
    }
  };

  const handleAnimationEnd = () => {
    if (!isMenuOpen) {
      setShouldRemove(true);
    }
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    }

    return () => {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    };
  }, [isMenuOpen]);

  return (
    <div className="nav-header-wrapper">
      <nav className="nav-header">
        <Link
          to={{
            pathname: "/",
            state: { prevPath: window.location.pathname },
          }}
          className={`nav-header__logo ${
            isMenuOpen
              ? "nav-header__mobile-logo--hidden"
              : !isMenuOpen && isMenuToggled
                ? "nav-header__mobile-logo--open"
                : ""
          }`}
        >
          <picture>
            {/* Mobile */}
            <source
              media="(max-width: 600px)"
              sizes="64px"
              srcSet="
              /assets/logos/logo-written-red--mobile-1x.webp 64w,
              /assets/logos/logo-written-red--mobile-2x.webp 128w,
              /assets/logos/logo-written-red--mobile-3x.webp 192w,
              /assets/logos/logo-written-red--mobile-4x.webp 256w"
            />

            {/* Tablet & Desktop */}
            <source
              media="(min-width: 601px)"
              sizes="128px"
              srcSet="
              /assets/logos/logo-written-red-1x.webp 128w,
              /assets/logos/logo-written-red-2x.webp 256w,
              /assets/logos/logo-written-red-3x.webp 384w,
              /assets/logos/logo-written-red-4x.webp 512w"
            />

            {/* Fallback */}
            <img
              className="logo-written"
              src="/assets/logos/logo-written-red-1x.webp"
              alt="Hiko"
            />
          </picture>
        </Link>

        <div className="nav-header__mobile-menu-icons" onClick={toggleMenu}>
          {isMenuOpen ? <IconMobileMenuClose /> : <IconMobileMenu />}
        </div>
      </nav>

      {!shouldRemove && (
        <div
          className={`nav-header__mobile-menu ${
            isMenuOpen ? "open" : "closed"
          }`}
          onAnimationEnd={handleAnimationEnd}
        >
          <ul>
            <li>
              <a
                href="#"
                role="button"
                aria-label="Download the app for your device, opens in a new tab"
                onClick={handleDownloadClick}
              >
                download the app
              </a>
            </li>

            <li>
              <a href={EMAIL} aria-label="Email us at contact@hiko.com">
                contact us
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Nav;
